var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('feather-icon',{staticClass:"draggable-item cursor-move",attrs:{"icon":"MenuIcon","size":"18"}}),(_vm.value)?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.value))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }